import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=b52d13fe&scoped=true"
import script from "./home.ts?vue&type=script&lang=ts&external"
export * from "./home.ts?vue&type=script&lang=ts&external"
import style0 from "./Home.vue?vue&type=style&index=0&id=b52d13fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52d13fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b52d13fe')) {
      api.createRecord('b52d13fe', component.options)
    } else {
      api.reload('b52d13fe', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=b52d13fe&scoped=true", function () {
      api.rerender('b52d13fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/home/Home.vue"
export default component.exports